import React from 'react';
import { StatusBadge } from '../../../../components/ui/badge/StatusBadge';

interface CpBatchDataProps {
  cpListPrice: string | undefined;
  cpProductStatus: string | undefined;
  cpShippingDate: string | undefined;
  cpLastScrapedAt: string | undefined;
  cpLastError: string | undefined;
}

export const CpBatchData: React.FC<CpBatchDataProps> = ({
  cpListPrice,
  cpProductStatus,
  cpShippingDate,
  cpLastScrapedAt,
  cpLastError,
}) => {
  if (!cpListPrice && !cpProductStatus && !cpShippingDate && !cpLastScrapedAt) {
    return null;
  }

  return (
    <div className="p-2 bg-light rounded" style={{ fontSize: '0.75em' }}>
      <div className="fw-bold text-muted mb-2" style={{ fontSize: '0.75rem' }}>
        CP-03 Batch Data
      </div>
      <div className="row g-2">
        {/* Row 1: CP List Price | CP Last Scraped At */}
        <div className="col-6">
          {cpListPrice ? (
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted">CP List Price:</span>
              <span className="fw-bold">₩{cpListPrice}</span>
            </div>
          ) : (
            <div className="text-muted">-</div>
          )}
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted">CP Last Scraped At:</span>
            <span>{cpLastScrapedAt ? `${cpLastScrapedAt} (UTC)` : '-'}</span>
          </div>
        </div>

        {/* Row 2: CP Product Status | CP Shipping Date */}
        <div className="col-6">
          <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted">CP Product Status:</span>
              {cpProductStatus ? (
                <StatusBadge type="cpProductStatus" value={cpProductStatus} size="sm" />
              ) : (
                <span>-</span>
              )}
            </div>
            {cpLastError && (
              <div className="text-danger" style={{ fontSize: '0.65rem' }}>
                {cpLastError}
              </div>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted">CP Shipping Date:</span>
            <span>{cpShippingDate ? `${cpShippingDate} (KST)` : '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
